import React, {useState} from 'react';

import {useDispatch, useSelector} from 'react-redux';

import {LazyTooltip} from 'app/components/general/LazyTooltip';
import {DocumentAlertBox} from 'app/general/structures/document-alerts/DocumentAlertBox';
import {
  selectIsHidingDataAccessInfoBox,
  toggleIsHidingDataAccessInfoBox,
} from 'app/openai/slice';
import {useAccountSettingsState} from 'app/settings/api';
import {gt} from 'app/utils/i18n';

import {
  HideDataGatheringButton,
  PermitDataGatheringInfoModal,
} from './PermitDataGatheringInfoModal';

export const PermitOpenaiDataGathering = () => {
  const dispatch = useDispatch();
  const isHidingDataAccessInfoBox = useSelector(
    selectIsHidingDataAccessInfoBox
  );

  const {require_ai_data_sharing_at} = useAccountSettingsState().data!;

  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);

  const title = gt('Tailor SweetAI reponses to your company data.');

  if (require_ai_data_sharing_at) {
    return null;
  }
  return isHidingDataAccessInfoBox ? (
    <div className="float-left m-1">
      <button
        onClick={() => dispatch(toggleIsHidingDataAccessInfoBox())}
        className="btn btn-sm"
      >
        <LazyTooltip tooltip={title}>
          <span>
            <i className="fa fa-fw fa-question-circle"></i>
          </span>
        </LazyTooltip>
      </button>
    </div>
  ) : (
    <DocumentAlertBox
      type="info"
      icon="fa-question-circle"
      title={title}
      content={
        <div>
          <PermitDataGatheringInfoModal
            isOpen={isInfoModalOpen}
            toggleModal={() => setIsInfoModalOpen(false)}
          />
          <button
            onClick={() => setIsInfoModalOpen(true)}
            className="btn btn-link btn-sm"
          >
            {gt('Tell me more')}
          </button>
          <HideDataGatheringButton />
        </div>
      }
    />
  );
};
